import { bb } from 'billboard.js';

/**
   * @function generateChart
   *
   * @description
   * generates the charts bases on the options instance
   *
   * @returns {Object} the generated chart instance
   */
export const createGenerateChart = instance => () => {
  const options = Object.assign({
    bindto: instance.$el,
  }, instance.options);
  return bb.generate(options);
};

/**
 * @function destoryChart
 *
 * @description
 * destorys the chart and sets ref to null
 */
export const createDestoryChart = instance => () => {
  try {
    instance.$chart.destory();
    instance.$chart = null; //eslint-disable-line
  } catch (error) {
    console.error('Internal Billboard.js error', error); //eslint-disable-line
  }
};

/**
   * @function loadDataChart
   *
   * @description
   * Updates the chart with the new data
   *
   * @param {object} options from instance to update the chart with
   */
export const createLoadDataChart = instance => (data) => {
  if (!instance.$chart) {
    instance.$chart = instance.generateChart(instance.options); //eslint-disable-line
  }
  instance.$chart.load(data);
};

export const unLoadDataChart = instance => (data) => {
  if (!instance.$chart) {
    instance.$chart = instance.generateChart(instance.options); //eslint-disable-line
  }
  instance.$chart.unload(data);
};



// WEBPACK FOOTER //
// ./src/modules/chart/components/Chart/chartMethods.js